import * as React from "react";
import { Download, FileText, HardDrive } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
const resources = [{
  title: "Market Volatility Metrics",
  description: "A quantitative assessment of rental price fluctuations across major metropolitan areas, providing a baseline for institutional risk modeling.",
  fileType: "DATA",
  fileSize: "1.4 MB",
  downloadUrl: "/MethodologyPage"
}, {
  title: "Exposure Weighting Framework",
  description: "Technical documentation detailing the algorithmic weighting of demographic shifts and supply-side constraints within the index.",
  fileType: "TECH",
  fileSize: "0.9 MB",
  downloadUrl: "/MethodologyPage"
}];
export default function DownloadResourcesGrid() {
  return <section data-section-id="253811" id="index-overview" className="bg-background text-foreground py-16 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-left grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
          <div className="lg:col-span-6">
            <h2 className="text-[32px] font-bold tracking-tight font-default text-foreground mb-4">
              Rental Exposure Index Objective
            </h2>
            <p className="text-base leading-[1.6] text-muted-foreground font-sans">
              The Rental Exposure Index (REI) provides institutional investors and policy makers with a standardized metric to evaluate market vulnerability. By synthesizing multi-source data points, the index identifies regions where rental costs significantly outpace local economic growth, highlighting potential areas of systemic financial stress.
            </p>
          </div>
          <div className="lg:col-span-6 hidden lg:block">
            {/* This empty div maintains the 12-column grid structure while focusing content on the left as per description */}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {resources.map((resource, i) => <Card key={i} data-index={i} className="flex flex-col h-full border-border border-[0.5px] rounded-none shadow-none hover:bg-muted/30 transition-colors duration-200">
              <CardHeader>
                <div className="w-12 h-12 rounded-none bg-transparent flex items-center justify-center mb-4">
                  <FileText className="w-6 h-6 text-primary stroke-[1.5px]" />
                </div>
                <CardTitle className="text-sm font-mono font-medium uppercase tracking-wider text-foreground">
                  {resource.title}
                </CardTitle>
                <CardDescription className="text-sm mt-2 font-sans leading-relaxed">
                  {resource.description}
                </CardDescription>
              </CardHeader>
              <CardContent className="flex-grow">
                <div className="flex items-center gap-4 text-[12px] font-mono text-muted-foreground uppercase">
                  <span className="flex items-center gap-1.5">
                    <FileText className="w-3.5 h-3.5 stroke-[1.5px]" />
                    {resource.fileType}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <HardDrive className="w-3.5 h-3.5 stroke-[1.5px]" />
                    {resource.fileSize}
                  </span>
                </div>
              </CardContent>
              <CardFooter className="pt-4 border-t border-border border-[0.5px] mt-auto">
                <Button asChild className="w-full sm:w-auto rounded-none bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-xs uppercase tracking-widest">
                  <Link to={resource.downloadUrl}>
                    <Download className="w-3.5 h-3.5 mr-2 stroke-[1.5px]" />
                    Access Documentation
                  </Link>
                </Button>
              </CardFooter>
            </Card>)}
        </div>
      </div>
    </section>;
}